@use "foundation/colors" as colors;

.stripe-load-error {
  color: colors.$neutrals-dark-grey;
  font-size: 14px;
  margin-top: 12px;
  text-align: center;

  p {
    margin-bottom: 8px;
  }
}

.stripe-load-placeholder {
  color: colors.$neutrals-dark-grey;
  font-size: 14px;
  font-weight: 600;
  margin-top: 12px;
  text-align: center;
}
